import React from "react";

const PrivacyPolicy = () => {
  return (
    <div className="policy-container">
      <h1>Privacy Policy</h1>

      <p>
        At <strong>Ora Bike</strong>, your privacy is important to us. This Privacy Policy describes how we collect, use, and protect your information when you interact with our website, products, or services.
      </p>

      <h2>1. Information We Collect</h2>
      <p>
        We may collect and store the following types of personal and usage information:
      </p>
      <ul>
        <li>Your name, email address, phone number, and postal address.</li>
        <li>Vehicle purchase and warranty registration details.</li>
        <li>Billing and payment information (processed securely via third-party gateways).</li>
        <li>Technical data such as browser type, device type, and IP address.</li>
        <li>Feedback, reviews, and service-related communications.</li>
      </ul>

      <h2>2. How We Use Your Information</h2>
      <p>
        Information collected is used for the following purposes:
      </p>
      <ul>
        <li>To process vehicle purchases, warranty registration, and service requests.</li>
        <li>To communicate important updates regarding your EV or service status.</li>
        <li>To improve user experience across our platforms and support channels.</li>
        <li>To prevent fraud, ensure safety, and comply with regulatory requirements.</li>
        <li>To provide promotional offers or updates (only if you opt in).</li>
      </ul>

      <h2>3. Information Sharing</h2>
      <p>
        Ora Bike does not sell or rent your personal data. However, we may share limited data:
      </p>
      <ul>
        <li>With authorized service centers and engineers for warranty and repair support.</li>
        <li>With trusted logistics and payment gateway providers.</li>
        <li>With legal authorities when required by law or in response to lawful requests.</li>
      </ul>

      <h2>4. Data Security</h2>
      <p>
        We follow industry-standard protocols and encryption methods to ensure your data is safe from unauthorized access, alteration, or misuse.
      </p>

      <h2>5. Your Rights</h2>
      <p>
        As a user, you have the right to:
      </p>
      <ul>
        <li>Request access to or deletion of your personal data.</li>
        <li>Update or correct your information at any time.</li>
        <li>Withdraw consent for marketing communications.</li>
        <li>Raise a complaint or query about data handling at Ora Bike.</li>
      </ul>

      <h2>6. Cookies & Tracking</h2>
      <p>
        We use cookies to analyze site traffic and enhance user experience. You can choose to disable cookies in your browser settings if you prefer.
      </p>

      <h2>7. Updates to this Policy</h2>
      <p>
        Ora Bike may update this Privacy Policy from time to time. Any significant changes will be posted on our website with an updated effective date.
      </p>

      <h2>8. Contact Us</h2>
      <p>
        If you have questions or concerns regarding this Privacy Policy, feel free to reach us at:
        <br />
        <strong>info@orabike.in</strong>
        <br />
       +91-2269711724
      </p>
    </div>
  );
};

export default PrivacyPolicy;
